var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainedLearners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_875_29651)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#68A395",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_875_29651)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0007 10.1562C14.3911 10.1562 13.084 11.4633 13.084 13.0729C13.084 14.6825 14.3911 15.9896 16.0007 15.9896C17.6102 15.9896 18.9173 14.6825 18.9173 13.0729C18.9173 11.4633 17.6102 10.1562 16.0007 10.1562ZM16.0007 10.9896C17.1507 10.9896 18.084 11.9229 18.084 13.0729C18.084 14.2229 17.1507 15.1562 16.0007 15.1562C14.8507 15.1562 13.9173 14.2229 13.9173 13.0729C13.9173 11.9229 14.8507 10.9896 16.0007 10.9896Z",
    fill: "#68A395"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0013 20.9948H16.0013C16.2313 20.9948 16.418 21.1815 16.418 21.4115C16.418 21.6415 16.2313 21.8281 16.0013 21.8281H10.5846C10.3546 21.8281 10.168 21.6415 10.168 21.4115C10.168 21.4115 10.168 21.0677 10.168 20.5781C10.168 18.5069 11.8467 16.8281 13.918 16.8281H16.0013C16.2313 16.8281 16.418 17.0148 16.418 17.2448C16.418 17.4748 16.2313 17.6615 16.0013 17.6615H13.918C12.3071 17.6615 11.0013 18.9673 11.0013 20.5781V20.9948Z",
    fill: "#68A395"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5419 16.8281C18.0473 16.8281 16.834 18.0415 16.834 19.536C16.834 21.0306 18.0473 22.244 19.5419 22.244C21.0365 22.244 22.2498 21.0306 22.2498 19.536C22.2498 18.0415 21.0365 16.8281 19.5419 16.8281ZM19.5419 17.6615C20.5765 17.6615 21.4165 18.5015 21.4165 19.536C21.4165 20.5706 20.5765 21.4106 19.5419 21.4106C18.5073 21.4106 17.6673 20.5706 17.6673 19.536C17.6673 18.5015 18.5073 17.6615 19.5419 17.6615Z",
    fill: "#68A395"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.369 19.5683L20.2852 18.6262C20.4456 18.4612 20.7098 18.4575 20.8744 18.6179C21.0394 18.7783 21.0431 19.0421 20.8827 19.2071L19.6677 20.4562C19.5894 20.5371 19.4815 20.5825 19.369 20.5825C19.2565 20.5825 19.149 20.5371 19.0702 20.4562L18.2019 19.5633C18.0415 19.3983 18.0452 19.1346 18.2102 18.9742C18.3752 18.8137 18.639 18.8175 18.7994 18.9825L19.369 19.5683Z",
    fill: "#68A395"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_875_29651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_875_29651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(9.33398 9.32812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainedLearners);
export default __webpack_public_path__ + "static/media/trained_learners.64789a6889b9fee7b1ec3c1aaf6e9346.svg";
export { ForwardRef as ReactComponent };